import { gql } from '@apollo/client';

const PATCH_COURSE = gql`
    mutation patchCourse($input: CourseInput!) {
        result: patchCourse(input: $input) {
            id
            locales {
                locale
                name
                description
            }
            thumbnailImage {
                id
                name
                url
                __typename
            }
            heroImage {
                id
                name
                url
                __typename
            }
            points
            isPublic
            enrollmentCount
            learningObjects {
                edges {
                    assignment {
                        status
                        scormState
                        __typename
                    }
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        duration
                        content {
                            id
                            url
                            __typename
                        }
                        __typename
                    }
                    __typename
                }
                __typename
            }
            tagIds
            categoryIds
            segmentIds
            brandIds
            localeIds
            companyRelationshipIds
            metadata
            createdAt
            updatedAt
        }
    }
`;

export default PATCH_COURSE;
